import { nullable } from "@flockcover/platform-types-utility"
import type {
  BBox,
  Feature,
  FeatureCollection,
  GeoJSON,
  GeoJsonProperties,
  Geometry,
  Position,
  LineString,
  Point,
} from "geojson"
import * as t from "io-ts"
import type { Layer, PathOptions } from "leaflet"

export const PointFeaturePropertiesType = t.intersection([
  t.type({
    timestamp: t.string,
    uid: t.string,
    fix: t.number,
    messageType: t.number,
    heading: nullable(t.number),
    speedMph: t.number,
  }),
  t.partial({
    routeLinkSeqNrMatched: t.number,
    mapped_lat: t.number,
    mapped_lng: t.number,
    original_lat: t.number,
    original_lng: t.number,
    confidenceValue: t.number,
    index: t.number,
  }),
])

export const LineStringFeaturePropertiesType = t.intersection([
  t.type({ speed: nullable(t.number), distance: t.number, speedLimit: nullable(t.number), wayId: t.string }),
  t.partial({
    wayPointFrom: t.number,
    wayPointTo: t.number,
    ratio: t.number,
    ignoreSpeeds: t.number,
    originalSpeed: t.number,
    regionName: t.string,
    townName: t.string,
    roadName: t.string,
    postcode: t.string,
    speedingCategory: t.number,
    functionalClass: t.number,
    gpsTimestamp: t.string,
    isUrban: t.boolean,
    eventType: t.string,
  }),
])
type PointFeatureProperties = t.TypeOf<typeof PointFeaturePropertiesType>
type LineStringFeatureProperties = t.TypeOf<typeof LineStringFeaturePropertiesType>

type GeoJson = {
  lineStrings: Array<Feature<LineString, LineStringFeatureProperties>>
  points: Array<Feature<Point, PointFeatureProperties>>
}

export type {
  BBox,
  GeoJson,
  Feature,
  FeatureCollection,
  GeoJSON,
  GeoJsonProperties,
  Geometry,
  Position,
  Layer,
  PointFeatureProperties,
  LineStringFeatureProperties,
  LineString,
  PathOptions,
  Point,
}
